<template>
  <div class="side-menu">
    <div class="scroll-area">
      <slot />
    </div>
  </div>
</template>

<script setup>
  defineProps({
    isAdmin: Boolean,
  });
</script>

<style lang="scss">
  @import '@sass/global/functions';
  @import '@sass/global/mixins';

  .side-menu {
    @apply bg-white
      rounded-lg
      transition
      max-w-full
      sticky
      top-[90px]
      w-full
      lg:w-[250px]
      xl:w-[280px]
      2xl:w-[330px]
      border;

    @include media(xl) {
      transform: translateX(0);
    }

    .scroll-area {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      overflow-y: auto;
      width: 100%;
      height: 100%;

      /**
       * Custom scrollbar
       */
      &::-webkit-scrollbar {
        width: size(8);
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(#000, 10%);
        display: none;

        &:hover {
          background-color: rgba(#000, 20%);
        }
      }

      &:hover {
        &::-webkit-scrollbar-thumb {
          display: block;
        }
      }

      nav {
        width: 100%;

        ul {
          @apply px-4 2xl:px-6 py-4 2xl:py-6;

          li {
            a {
              @apply rounded-lg text-base 2xl:text-lg flex items-center gap-4 px-4 py-2 2xl:px-6 2xl:py-4;

              color: color(--grey-300);
              font-weight: 900;
              transition: 0.1s ease-in-out;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;

              &:hover,
              &.active {
                color: color(--primary);
                background-color: rgba(#f00, 5%);

                .vxi {
                  transform: scale(1.1);
                }
              }

              &.active {
                pointer-events: none;
              }

              &.bottom-item {
                padding: size(16) size(24);
                font-weight: 400;
                font-size: size(18);

                * {
                  pointer-events: none;
                }
              }
            }

            .divider {
              height: size(1);
              background-color: color(--grey-50);
              margin: size(32) 0;
            }
          }
        }
      }

      footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: size(16) size(56);
        font-size: size(16);

        .brand {
          display: flex;
          gap: size(16);
          align-items: center;
          color: color(--grey-100);
        }
      }
    }
  }
</style>

<script>
  export default {
    mounted() {
      const navLink = document.querySelectorAll('.nav-link');

      navLink.forEach(el => {
        el.classList.remove('active');

        if (el.pathname === location.pathname && el.hash === location.hash) {
          el.classList.add('active');
        }
      });
    },
  };
</script>
